import React, { useState } from 'react';
import { useParams, Link } from 'react-router';
import { motion, AnimatePresence } from 'framer-motion';
import AnimacionPagina from '../componentes/AnimacionPagina';
import panelesDecorativos from '../data/todosLosProductos/panelesDecorativos';
import styled from 'styled-components';
import Header from '../componentes/Header';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import Footer from '../componentes/Footer';

import {FichaProducto, Galeria, MotionImagen, Flecha, Miniaturas, Miniatura} from '../elementos/GaleriaStyles'

const DetallesPaneles = () => {
  const { categoriaSlug, slug } = useParams();
  const producto = panelesDecorativos.find(
    p => p.slug === slug
  );

  const imagenInicial = producto?.images?.[0] || '';
  const [indiceSeleccionado, setIndiceSeleccionado] = useState(0);
  const [animando, setAnimando] = useState(false);
  

  if (!producto) return <h2>Producto no encontrado</h2>;

  const imagenActual = producto.images[indiceSeleccionado];
  const imagenDeMuestra = producto.images[0];
  const imagenesDeColores = producto.images.slice(1);

  const cambiarImagen = (index) => {
    if (index >= 0 && index < producto.images.length) {
      setAnimando(true);
      setTimeout(() => {
        setIndiceSeleccionado(index);
        setAnimando(false);
      }, 50);
    }
  };

  return (
    <>
    <Header />
    <AnimacionPagina>
      <FichaProducto>
      <h1>{producto.nombre}</h1>
      <h3>{producto.categoria}</h3>
      <p>Material: <b>{producto.material}</b></p>
      <p>Dimensiones: 
        <br/>
        <b>{producto.dimensiones}</b>
      </p>
      <p>Metros cuadrados: <b>{producto.metrosCuadradosPorPieza} metros cuadrados</b></p>
      <Galeria>
        <Flecha className='flechaBack' onClick={() => cambiarImagen(indiceSeleccionado - 1)}>&larr;</Flecha>
        <AnimatePresence mode="wait">
          <MotionImagen
            key={imagenActual}
            src={imagenActual}
            alt="Imagen seleccionada"
            initial={{ opacity: .5, scale: .5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
          />
        </AnimatePresence>
        <Flecha className='flechaSig' onClick={() => cambiarImagen(indiceSeleccionado + 1)}>&rarr;</Flecha>
      </Galeria>

     
      <Miniaturas> 
        <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.7 }}
        >
        <Miniatura
          activa={indiceSeleccionado === 0}
          onClick={() => cambiarImagen(0)}
        >
          <img src={imagenDeMuestra} alt="Muestra" />
          <span>Muestra</span>
        </Miniatura>
      </motion.div>
        
        {producto.colores.map((color, i) => (
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.7 }}
          >
          <Miniatura
            key={color}
            activa={indiceSeleccionado === i + 1}
            onClick={() => cambiarImagen(i + 1)}
          >
            <img src={imagenesDeColores[i]} alt={color} />
            <span>{color}</span>
          </Miniatura>
        </motion.div>
          
        ))}
      </Miniaturas>
          <BtnVolverAnim Ref='/paneles-decorativos'/>
          <WhatsAppShareButton message="¡Mira este modelo de panel!" />
      </FichaProducto>
      <Footer />
    </AnimacionPagina>
    </>
    
  );
};
const DivCertificaciones = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 4px;
  img{
    margin-top: 4px;
    height: 30px;
  }
`;

export default DetallesPaneles;